import AppDispatcher from '../../core/AppDispatcher'
import { appActions } from '../AppActions'
import UserEvent from '../../event/UserEvent'
import RoomRepository from '../../infra/RoomRepository'

const fetchUserRoomById = async roomId => {
  const response = await RoomRepository.fetchUserRoomById(roomId).catch(() => false)
  if (response === false) {
    appActions.showAlert('部屋情報の取得に失敗しました')
    return false
  }

  AppDispatcher.dispatchWithType(UserEvent.fetchUserRoomById, {
    room: response
  })

  return true
}

export default fetchUserRoomById
